import { useDrawingArea } from "@mui/x-charts"
import { Fragment } from "react"
import { extraColors } from "../../utils/theme"
import { Y_AXIS_LABEL_OFFSET } from "./wastewaterHeatmapConstants"

export const StripedBackground = ({ numRows }: { numRows: number }) => {
  const { left, top, width, height } = useDrawingArea()
  const patternId = "striped-background-pattern"
  const rowHeight = height / numRows
  const totalWidth = left + width

  return (
    <Fragment>
      <defs>
        <pattern
          id={patternId}
          x={0}
          y={top}
          width={totalWidth}
          height={rowHeight * 2}
          patternUnits="userSpaceOnUse"
        >
          <rect
            x={0}
            y={0}
            width={totalWidth}
            height={rowHeight}
            fill="transparent"
          />
          <rect
            x={0}
            y={rowHeight}
            width={totalWidth}
            height={rowHeight}
            fill={extraColors.translucent5}
          />
        </pattern>
      </defs>
      <rect
        x={Y_AXIS_LABEL_OFFSET}
        y={top}
        width={totalWidth}
        height={height}
        fill={`url(#${patternId})`}
        style={{ pointerEvents: "none" }}
      />
    </Fragment>
  )
}
